import styled from 'styled-components';

export const Container = styled.footer`
  width: calc(100% + 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  height: 2.5rem;
  border-top: solid 1px #e6e7e9;
  padding: 35px;
  background: #f7f8fc;
`;

export const TextFooter = styled.span`
  color: #898a8e;
  font-size: 15px;
`;
